import React, { Component } from 'react';

const DefaultQueryKey = '_k';
const KeyPrefix = '@@History/';

class Bundle extends Component {
  state = {
    // short for "module" but that's a keyword in js, so "mod"
    mod: null
  };

  componentWillMount() {
    this.load(this.props);

    this.initRouterState();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.load !== this.props.load) {
      this.load(nextProps);
    }
  }

  load(props) {
    this.setState({
      mod: null
    });
    props.load((mod) => {
      this.setState({
        // handle both es imports and cjs
        mod: mod.default ? mod.default : mod
      });
    });
  }

  /**
   * 当url包含_k=的参数时，初始化state参数
   */
  initRouterState() {
    const { search } = window.app.router.location;
    const keyIndex = search.indexOf(DefaultQueryKey);
    if (keyIndex >= 0) {
      window.app.router.location.state = JSON.parse(
        sessionStorage.getItem(KeyPrefix + search.substring(keyIndex + 3, keyIndex + 9))
      );
    }
  }

  render() {
    return this.props.children(this.state.mod);
  }
}

export default Bundle;



// WEBPACK FOOTER //
// ./src/widget/Common/Bundle.js